<input
  pInputText
  [(ngModel)]="displayValue"
  (ngModelChange)="displayValueChange($event)"
  [ngClass]="{
    'ng-invalid': formControl?.invalid,
    'ng-valid': formControl?.valid
  }"
  (focus)="onFocus()"
  (blur)="onBlur()"
  autocomplete="off"
  [class]="styleClass"
  [id]="id"
  [name]="name"
  [placeholder]="placeholder"
  [minlength]="minlength"
  [maxlength]="maxlength"
  [readonly]="readonly"
  [required]="required"
  [disabled]="disabled"
/>
